import { CategoryInventoryScan } from "@gull";

import { lazy, useContext } from "react";

// import DashboardBilling from "./DashboardBilling";

// import ChiffreAffaires from "./ChiffreAffaires";

const DashboardBilling = lazy(() => import("./DashboardBilling"));

const ChiffreAffaires = lazy(() => import("./ChiffreAffaires"));

const CreateBillingGeneral = lazy(() => import("./CreateComp/CreateBillingGeneral"));

const CreateFormAddItems = lazy(() => import("./CreateComp/CreateFormAddItems"));

const SearchBilling = lazy(() => import("./SearchBilling"));

// const EndBilling = lazy(() => import("./EndBilling"));

const TemplateBilling = lazy(() => import("./TemplateBilling"));

const TemplateEmail = lazy(() => import("./TemplateEmail"));

const RecurrenceBilling = lazy(() => import("./RecurrenceBilling"));

const NotificationListErp = lazy(() => import("./Notification/NotificationListErp"));

const NotificationDetailErp = lazy(() => import("./Notification/NotificationDetailErp"));

const LicenceNotificationDetail = lazy(() => import("../notifications/LicenceNotificationDetail"));

const HistoriqueDetail = lazy(() => import("./Historique/HistoriqueDetail"));

const MainViewDocument = lazy(() => import("./DetailDocumentComp/MainViewDocument"));

const FacturationReport = lazy (()=> import("./ReportPbi/FacturationReport"))

const DetailDossier = lazy (()=> import("./Dossier/DetailDossier"))

const ConvertDocToPo = lazy (()=> import("./ConvertDocToPo/ConvertDocToPo"))

const ConvertDocToReturnNote = lazy (()=> import("./ConvertDocToReturnNote/ConvertDocToReturnNote"))

const ConvertDocToCreditNote = lazy (()=> import("./ConvertDocToCreditNote/ConvertDocToCreditNote"))

const ConvertDocToCreditNoteBuy = lazy (()=> import("./ConvertDocToCreditNoteBuy/ConvertDocToCreditNoteBuy"))

const ConvertDocToDeliveryNote = lazy (()=> import("./ConvertDocToDeliveryNote/ConvertDocToDeliveryNote"))

const MatchIdsInterne = lazy (()=> import("./MatchIdsInterne/MatchIdsInterne"))

const Client = lazy (()=> import("./Client/Client"))

const ClientFacturationGeneral = lazy (()=> import("./Client/ClientFacturationGeneral"))

const ExceptionRefacturation = lazy (()=> import("./Refacturation/ExceptionRefacturation"))

const ExceptionRefacturationDetail = lazy (()=> import("./Refacturation/ExceptionRefacturationDetail"))

const FactureInterSociete = lazy (()=> import("./Refacturation/FactureInterSociete"))



const facturationRoutes = [
    // ─── Dashboard ─────────────────────────────────────────────────────────────
    {
        path: "/invoice/dashboard",
        id: "facturation_dashboard",
        name: "[Facturation] Dashboard - /invoice/dashboard",
        component: DashboardBilling
    },
    // ─── Création de document & conversions ────────────────────────────────────
    {
        path: "/invoice/document/create",
        id: "facturation_document_create",
        name: "[Facturation] Création d'un document - /invoice/document/create",
        component: CreateBillingGeneral
    },
    {
        path: "/invoice/document/create-add-items/:id",
        id: "facturation_document_create_add_items",
        name: "[Facturation] Création d'un document - ajout d'articles et prévisualisation - /invoice/document/create-add-items/:id",
        component: CreateFormAddItems
    },
    {
        path: "/invoice/convert-to-purchase-order/:id",
        id: "facturation_convert_to_purchase_order",
        name: "[Facturation] Conversion en bon de commande - /invoice/convert-to-purchase-order/:id",
        component: ConvertDocToPo
    },
    {
        path: "/invoice/convert-to-return-order/:id",
        id: "facturation_convert_to_return_order",
        name: "[Facturation] Conversion en bon de retour - /invoice/convert-to-return-order/:id",
        component: ConvertDocToReturnNote
    },
    {
        path: "/invoice/convert-to-credit-note/:id",
        id: "facturation_convert_to_credit_note",
        name: "[Facturation] Conversion en avoir - /invoice/convert-to-credit-note/:id",
        component: ConvertDocToCreditNote
    },
    {
        path: "/invoice/convert-to-credit-note-buy/:id",
        id: "facturation_convert_to_credit_note_buy",
        name: "[Facturation] Conversion en avoir d'achat - /invoice/convert-to-credit-note-buy/:id",
        component: ConvertDocToCreditNoteBuy
    },
    {
        path: "/invoice/convert-to-delivery-note/:id",
        id: "facturation_convert_to_delivery_note",
        name: "[Facturation] Conversion en bon de livraison - /invoice/convert-to-delivery-note/:id",
        component: ConvertDocToDeliveryNote
    },
    {
        path: "/invoice/details/:id",
        id: "facturation_details",
        name: "[Facturation] Détail d'un document - /invoice/details/:id",
        component: MainViewDocument
    },
    {
        path: "/invoice/folder-detail/:id",
        id: "facturation_folder_detail",
        name: "[Facturation] Détail d'un dossier - /invoice/folder-detail/:id",
        component: DetailDossier
    },
    // ─── Clients ───────────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/invoice/client",
        id: "facturation_client",
        name: "[Facturation] Clients - /invoice/client",
        component: ClientFacturationGeneral
    },
    {
        exact:true,
        path: "/invoice/client/detail/:id",
        id: "facturation_client_detail",
        name: "[Facturation] Détail client - /invoice/client/detail/:id",
        component: Client
    },
    // ─── Chiffre d'affaires ────────────────────────────────────────────────────
    {
        path: "/invoice/chiffre_affaires",
        id: "facturation_chiffre_affaires",
        name: "[Facturation] Chiffre d'affaires - /invoice/chiffre_affaires",
        component: ChiffreAffaires
    },
    // ─── Récurrence ────────────────────────────────────────────────────────────
    {
        path: "/invoice/invoice/recurrence",
        id: "facturation_recurrence",
        name: "[Facturation] Récurrence - /invoice/invoice/recurrence",
        component: RecurrenceBilling
    },
    // ─── Recherche ─────────────────────────────────────────────────────────────
    {
        path: "/invoice/search",
        id: "facturation_search",
        name: "[Facturation] Recherche de documents - /invoice/search",
        component: SearchBilling
    },
    // ─── Rapport Power BI ──────────────────────────────────────────────────────
    {
        path: "/invoice/report",
        id: "facturation_report",
        // name: "[Facturation] Rapport Power BI - /invoice/report",
        component: FacturationReport
    },
    // ─── Correspondance ID interne ─────────────────────────────────────────────
    {
        path: "/invoice/internal-id-match",
        id: "facturation_internal_id_match",
        name: "[Facturation] Correspondance ID interne - /invoice/internal-id-match",
        component: MatchIdsInterne
    },
    // ─── Refacturation ─────────────────────────────────────────────────────────
    {
        exact:true,
        path: "/invoice/exception_refacturation",
        id: "facturation_exception_refacturation",
        name: "[Facturation] Exceptions de refacturation - /invoice/exception_refacturation",
        component: ExceptionRefacturation
    },
    {
        exact:true,
        path: "/invoice/exception_refacturation/detail/:id",
        id: "facturation_exception_refacturation_detail",
        name: "[Facturation] Détail exception de refacturation - /invoice/exception_refacturation/detail/:id",
        component: ExceptionRefacturationDetail
    },
    {
        exact:true,
        path: "/invoice/facture_inter_societe",
        id: "facturation_facture_inter_societe",
        name: "[Facturation] Factures inter-sociétés - /invoice/facture_inter_societe",
        component: FactureInterSociete
    },
    // ─── Modèles (entrées de menu actuellement commentées) ─────────────────────
    {
        path: "/invoice/invoice/template",
        id: "facturation_template",
        // name: "[Facturation] Modèle de facture - /invoice/invoice/template",
        component: TemplateBilling
    },
    {
        path: "/invoice/email/template",
        id: "facturation_email_template",
        // name: "[Facturation] Modèle d'email - /invoice/email/template",
        component: TemplateEmail
    },
    // ─── Notifications & historique (hors menu) ────────────────────────────────
    {
        path: "/invoice/notifications/list",
        id: "facturation_notifications_list",
        // name: "[Facturation] Liste des notifications - /invoice/notifications/list",
        component: NotificationListErp
    },
    {
        path: "/invoice/notifications/detail/:id",
        id: "facturation_notifications_detail",
        // name: "[Facturation] Détail notification - /invoice/notifications/detail/:id",
        component: NotificationDetailErp
    },
    {
        path: "/invoice/notifications/licence-notification/:licenceNotificationId",
        id: "facturation_notifications_licence_detail",
        // name: "[Facturation] Détail notification licence - /invoice/notifications/licence-notification/:licenceNotificationId",
        component: LicenceNotificationDetail
    },
    {
        path: "/invoice/historique/edit/:id",
        id: "facturation_historique_edit",
        // name: "[Facturation] Détail historique - /invoice/historique/edit/:id",
        component: HistoriqueDetail
    },
];

export default facturationRoutes;
